import { Component } from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import { Results} from '../results/results'
import {UserData} from "../services/UserData";
import { AlertController } from 'ionic-angular';
import {HTTP} from "@ionic-native/http";

@Component({
    selector: 'guest-data',
    templateUrl: 'guest-data.html'
})
export class GuestData {
    userData: UserData

    http : HTTP;
    constructor(public navCtrl: NavController, navParams: NavParams, http: HTTP, private alertCtrl: AlertController, public loadingCtrl: LoadingController) {
        this.userData = navParams.data;
        this.http = http;
    }

    presentLoading() {
        let loading = this.loadingCtrl.create({
            spinner: 'dots',
            content: 'Please wait...'
        });

        loading.present();
        return loading;
    }

    submitData () {
        if (this.userData.roomNumber=='')
        {
            let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Please enter your room number',
                buttons: ['OK']
            });
            alert.present();
        }
        else {
            var link = 'http://www.lero.mint-media.hr/ankete/API/v1/handler.php';
            var dataStringified = JSON.stringify({object: this.userData});
            var dataObject = JSON.parse(dataStringified);
            // var headers = new Headers();
            // headers.append('Content-Type', 'applicaton/json');

            var loader=this.presentLoading();

            //this.http.post(link, dataObject , headers).then(response => {
            this.http.post(link, dataObject , {'Content-Type':'applicaton/json'}).then(response => {
                console.log(response.status);
                console.log(response.data); // data received by server
                console.log(response.headers);
                loader.dismiss();
                this.navCtrl.push(Results, this.userData);
            })
                .catch(error => {
                    loader.dismiss();
                    console.log(error);
                    console.log(error.status);
                    console.log(error.error); // error message as string
                    console.log(error.headers);

                    let alert = this.alertCtrl.create({
                        title: 'Internet connection error',
                        subTitle: 'Please check your internet connection',
                        buttons: ['OK']
                    });
                    alert.present();
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/guest-data/guest-data.ts